<div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
        <div class="modal-header">
            <h2 class="modal-title"> بررسی اطلاعات مالک شناور </h2>
        </div>
        <div class="modal-body">
            <div class="alert alert-warning alert-compact">
                <p>این طرح صرفاً به‌منظور تخصیص سوخت به دارندگان مجوز صیادی معتبر صادره از سازمان شیلات اجرا
                    می‌گردد. بدیهی است ثبت‌نام افراد فاقد مجوز معتبر، هیچ‌گونه تعهدی برای سازمان شیلات در خصوص تخصیص
                    سوخت ایجاد نخواهد کرد. </p>
            </div>

            <p class="text-muted mb-2" style="font-size: 12px;">شماره موبایل یا شماره مجوز قایق را وارد کنید.</p>

            <div class="form-group has-icon" [ngClass]="strMobileField.value ? 'direction-ltr' : ''">
                <span class="form-control-icon">
                    <mat-icon>phone_iphone</mat-icon>
                </span>

                <input type="search" class="form-control" [disabled]="isSubmitDisabled" #strMobileField="ngModel"
                    [(ngModel)]="strMobile" (ngModelChange)="onMobileChange($event, strLicenseNoField)" appPhoneNumberValidation [maxLength]="11" [minlength]="11"
                    placeholder="شماره موبایل" inputmode="numeric"
                    oninput="this.value=this.value.replace(/[^0-9]/g,'')" (keydown.enter)="submit(strMobileField, strLicenseNoField)"
                    autofocus />

                <ng-container *ngIf="strMobile && strMobileField.invalid && strMobileField.touched">
                    <small class="text-danger"> شماره موبایل را به درستی وارد کنید </small>
                </ng-container>
            </div>

            <div class="form-group has-icon mb-0">
                <span class="form-control-icon">
                    <mat-icon>verified</mat-icon>
                </span>

                <input type="search" class="form-control" [disabled]="isSubmitDisabled" #strLicenseNoField="ngModel"
                    [(ngModel)]="strLicenseNo" (ngModelChange)="onLicenseChange($event, strMobileField)"
                    placeholder="شماره مجوز قایق"
                    (keydown.enter)="submit(strMobileField, strLicenseNoField)" />
            </div>
        </div>
        <div class="modal-footer d-flex flex-row-reverse justify-content-end">
            <button type="button" class="btn btn-primary"
                [disabled]="isSubmitDisabled || (!strMobile && !strLicenseNo) || (strMobile && strMobileField.invalid)"
                (click)="submit(strMobileField, strLicenseNoField)"> بررسی </button>
        </div>
    </div>
</div>

<!-- Vessel List Dialog -->
<ng-template #vesselListDialogTemplate let-modal>
    <div class="modal-header">
        <h2 class="modal-title">شناورهای ثبت شده - {{ strMobile || strLicenseNo }}</h2>
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.close()"></button>
    </div>
    <div class="modal-body">
        <div class="d-flex justify-content-start mb-3">
            <button type="button" class="btn btn-success" (click)="addNewVessel()">+ ثبت شناور جدید</button>
        </div>
        <div class="table-responsive" *ngIf="vesselList?.length; else noVesselTemplate">
            <table class="app-table">
                <thead>
                    <tr>
                        <th class="fw-bold">عملیات</th>
                        <th class="fw-bold">شماره</th>
                        <th class="fw-bold">نام و نام خانوادگی</th>
                        <th class="fw-bold">شناسه شناور</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let vessel of vesselList">
                        <td>
                            <button type="button" class="btn btn-primary btn-sm"
                                [disabled]="editLoadingId === vessel.iPreregistration"
                                (click)="editVessel(vessel)">ویرایش</button>
                        </td>
                        <td>{{ vessel.iPreregistration }}</td>
                        <td>{{ vessel.strName }} {{ vessel.strFamily }}</td>
                        <td>{{ vessel.strLicenseNo || '-' }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <ng-template #noVesselTemplate>
            <p class="text-muted">موردی یافت نشد.</p>
        </ng-template>
    </div>
</ng-template>

<!-- Details / Edit Dialog -->
<ng-template #detailsDialogTemplate let-modal>
    <div class="modal-header">
        <h2 class="modal-title">ویرایش اطلاعات
            <span class="status-badge"
                [class.status-ok]="formGroup.get('tiInstallationStatus')?.value !== 0"
                [class.status-bad]="formGroup.get('tiInstallationStatus')?.value == 0">
                {{ formGroup.get('strInstallationStatus')?.value }}
            </span>
        </h2>
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.close()"></button>
    </div>

    <div class="modal-body">
        <form [formGroup]="formGroup" (ngSubmit)="submitForm()">
            <div class="row g-2">

                <div class="col-md-6 field">
                    <label class="field-label" for="f-strName">نام <span class="req">*</span></label>
                    <div class="form-group has-icon">
                        <span class="form-control-icon"><mat-icon>account_circle</mat-icon></span>
                        <input id="f-strName" type="text" class="form-control" formControlName="strName"
                            placeholder="نام" />
                    </div>
                    <small class="field-error" *ngIf="invalid('strName')">نام الزامی است</small>
                </div>

                <div class="col-md-6 field">
                    <label class="field-label" for="f-strFamily">نام خانوادگی <span class="req">*</span></label>
                    <div class="form-group has-icon">
                        <span class="form-control-icon"><mat-icon>account_circle</mat-icon></span>
                        <input id="f-strFamily" type="text" class="form-control" formControlName="strFamily"
                            placeholder="نام خانوادگی" />
                    </div>
                    <small class="field-error" *ngIf="invalid('strFamily')">نام خانوادگی الزامی است</small>
                </div>

                <div class="col-md-6 field">
                    <label class="field-label" for="f-strID">کد ملی <span class="req">*</span></label>
                    <div class="form-group has-icon" [ngClass]="formGroup.get('strID')?.value ? 'direction-ltr' : ''">
                        <span class="form-control-icon"><mat-icon>badge</mat-icon></span>
                        <input id="f-strID" class="form-control" formControlName="strID" inputmode="numeric"
                            maxlength="10" oninput="this.value=this.value.replace(/[^0-9]/g,'')"
                            placeholder="کد ملی ۱۰ رقمی" />
                    </div>
                    <small class="field-error" *ngIf="invalid('strID')">کد ملی معتبر وارد کنید</small>
                </div>

                <div class="col-md-6 field">
                    <label class="field-label" for="f-strMobile">موبایل</label>
                    <div class="form-group has-icon"
                        [ngClass]="formGroup.get('strMobile')?.value ? 'direction-ltr' : ''">
                        <span class="form-control-icon"><mat-icon>phone_iphone</mat-icon></span>
                        <input id="f-strMobile" type="text" class="form-control" formControlName="strMobile"
                            inputmode="numeric" maxlength="11"
                            oninput="this.value=this.value.replace(/[^0-9]/g,'')"
                            placeholder="09123456789" />
                    </div>
                    <small class="field-error" *ngIf="invalid('strMobile')">شماره موبایل معتبر وارد کنید</small>
                </div>

                <div class="col-md-6 field">
                    <label class="field-label" for="f-strLicenseNo">شماره پروانه</label>
                    <div class="form-group has-icon">
                        <span class="form-control-icon"><mat-icon>verified</mat-icon></span>
                        <input id="f-strLicenseNo" type="text" class="form-control" formControlName="strLicenseNo"
                            placeholder="شماره پروانه" />
                    </div>
                </div>

                <div class="col-md-6 field">
                    <label class="field-label" for="f-strState">استان <span class="req">*</span></label>
                    <div class="form-group has-icon">
                        <span class="form-control-icon"><mat-icon>apartment</mat-icon></span>
                        <select id="f-strState" formControlName="strState"
                            (change)="onStateChange($event.target.value)">
                            <option [ngValue]="null" disabled>انتخاب کنید</option>
                            <option *ngFor="let state of states$ | async" [value]="state.strState">{{
                                state.strStateName }}</option>
                        </select>
                    </div>
                </div>

                <div class="col-md-6 field">
                    <label class="field-label" for="f-strCity">شهر <span class="req">*</span></label>
                    <div class="form-group has-icon">
                        <span class="form-control-icon"><mat-icon>apartment</mat-icon></span>
                        <select id="f-strCity" formControlName="strCity">
                            <option [ngValue]="null" disabled>انتخاب کنید</option>
                            <option *ngFor="let city of cities$ | async" [ngValue]="city.strCity">{{ city.strCityName }}
                            </option>
                        </select>
                    </div>
                    <small class="field-error" *ngIf="invalid('strCity')">شهر الزامی است</small>
                </div>

                <div class="col-md-6 field">
                    <label class="field-label" for="f-tiFloatingType">نوع شناور <span class="req">*</span></label>
                    <div class="form-group has-icon">
                        <span class="form-control-icon"><mat-icon>directions_boat</mat-icon></span>
                        <select id="f-tiFloatingType" formControlName="tiFloatingType">
                            <option [ngValue]="null" disabled>انتخاب کنید</option>
                            <option *ngFor="let floatingType of floatingType$ | async"
                                [ngValue]="floatingType.tiFloatingType">{{ floatingType.strFloatingType }}</option>
                        </select>
                    </div>
                    <small class="field-error" *ngIf="invalid('tiFloatingType')">نوع شناور الزامی است</small>
                </div>

                <div class="col-md-6 field">
                    <label class="field-label" for="f-iPower">قدرت موتور <span class="req">*</span></label>
                    <div class="form-group has-icon"
                        [ngClass]="formGroup.get('iPower')?.value ? 'direction-ltr' : ''">
                        <span class="form-control-icon"><mat-icon>electric_bolt</mat-icon></span>
                        <input id="f-iPower" class="form-control" formControlName="iPower" inputmode="numeric"
                            oninput="this.value=this.value.replace(/[^0-9]/g,'')"
                            placeholder="قدرت موتور" />
                    </div>
                    <small class="field-error" *ngIf="invalid('iPower')">قدرت موتور الزامی است</small>
                </div>

                <div class="col-md-6 field">
                    <label class="field-label" for="f-strVIN">شماره موتور</label>
                    <div class="form-group has-icon"
                        [ngClass]="formGroup.get('strVIN')?.value ? 'direction-ltr' : ''">
                        <span class="form-control-icon"><mat-icon>numbers</mat-icon></span>
                        <input id="f-strVIN" class="form-control" formControlName="strVIN"
                            placeholder="شماره موتور" />
                    </div>
                    <small class="field-error" *ngIf="invalid('strVIN')">شماره موتور الزامی است</small>
                </div>

                <div class="col-12 field">
                    <label class="field-label" for="f-strAddress">آدرس</label>
                    <div class="form-group has-icon mb-0">
                        <span class="form-control-icon"><mat-icon>add_location_alt</mat-icon></span>
                        <input id="f-strAddress" class="form-control" formControlName="strAddress"
                            placeholder="آدرس محل نصب" />
                    </div>
                </div>

                <div class="col-12 field">
                    <label class="field-label" for="f-strComment">توضیحات</label>
                    <div class="form-group has-icon mb-0">
                        <span class="form-control-icon"><mat-icon>description</mat-icon></span>
                        <textarea id="f-strComment" class="form-control" rows="2"
                            formControlName="strComment" placeholder="توضیحات تکمیلی"></textarea>
                    </div>
                </div>

                <div class="col-12 field">
                    <label class="field-label">نوع پرداخت</label>
                    <div class="switch-inline-box">
                        <div class="form-check form-switch d-flex align-items-center">
                            <input class="form-check-input m-0" type="checkbox" id="editBInstallment"
                                formControlName="bInstallment" />
                            <label class="form-check-label pointer text-muted me-2" for="editBInstallment">اقساطی
                                بودن</label>
                        </div>
                    </div>
                </div>

                <div class="col-12 field" *ngIf="formGroup.get('bInstallment')?.value">
                    <label class="field-label" for="f-strPaymentComment">توضیحات پرداخت</label>
                    <div class="form-group has-icon highlight-box mb-0">
                        <span class="form-control-icon"><mat-icon>description</mat-icon></span>
                        <textarea id="f-strPaymentComment" class="form-control" rows="2"
                            formControlName="strPaymentComment" placeholder="شرایط اقساط"></textarea>
                    </div>
                </div>

                <div class="col-md-6 field">
                    <label class="field-label" for="f-iPayment1">قسط اول (ریال)</label>
                    <div class="form-group has-icon mb-0">
                        <span class="form-control-icon"><mat-icon>attach_money</mat-icon></span>
                        <input id="f-iPayment1" class="form-control text-start" formControlName="iPayment1"
                            inputmode="numeric" placeholder="مبلغ به ریال"
                            oninput="this.value=this.value.replace(/[^0-9]/g,'').toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')" />
                    </div>
                </div>

                <div class="col-md-6 field">
                    <label class="field-label" for="f-iTrackingCode">کد پیگیری (قسط اول)</label>
                    <div class="form-group has-icon mb-0"
                        [ngClass]="formGroup.get('iTrackingCode')?.value ? 'direction-ltr' : ''">
                        <span class="form-control-icon"><mat-icon>receipt</mat-icon></span>
                        <input id="f-iTrackingCode" class="form-control" formControlName="iTrackingCode"
                            inputmode="numeric" oninput="this.value=this.value.replace(/[^0-9]/g,'')"
                            placeholder="کد پیگیری" />
                    </div>
                </div>

                <div class="col-md-6 field">
                    <label class="field-label" for="f-iPayment2">قسط دوم (ریال)</label>
                    <div class="form-group has-icon mb-0">
                        <span class="form-control-icon"><mat-icon>attach_money</mat-icon></span>
                        <input id="f-iPayment2" class="form-control text-start" formControlName="iPayment2"
                            inputmode="numeric" placeholder="مبلغ به ریال"
                            oninput="this.value=this.value.replace(/[^0-9]/g,'').toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')" />
                    </div>
                </div>

                <div class="col-md-6 field">
                    <label class="field-label" for="f-iTrackingCode2">کد پیگیری قسط دوم</label>
                    <div class="form-group has-icon mb-0"
                        [ngClass]="formGroup.get('iTrackingCode2')?.value ? 'direction-ltr' : ''">
                        <span class="form-control-icon"><mat-icon>receipt</mat-icon></span>
                        <input id="f-iTrackingCode2" class="form-control" formControlName="iTrackingCode2"
                            inputmode="numeric" oninput="this.value=this.value.replace(/[^0-9]/g,'')"
                            placeholder="کد پیگیری" />
                    </div>
                </div>

                <div class="col-md-6 field">
                    <label class="field-label" for="f-iPayment3">قسط سوم (ریال)</label>
                    <div class="form-group has-icon mb-0">
                        <span class="form-control-icon"><mat-icon>attach_money</mat-icon></span>
                        <input id="f-iPayment3" class="form-control text-start" formControlName="iPayment3"
                            inputmode="numeric" placeholder="مبلغ به ریال"
                            oninput="this.value=this.value.replace(/[^0-9]/g,'').toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')" />
                    </div>
                </div>

                <div class="col-md-6 field">
                    <label class="field-label" for="f-iTrackingCode3">کد پیگیری قسط سوم</label>
                    <div class="form-group has-icon mb-0"
                        [ngClass]="formGroup.get('iTrackingCode3')?.value ? 'direction-ltr' : ''">
                        <span class="form-control-icon"><mat-icon>receipt</mat-icon></span>
                        <input id="f-iTrackingCode3" class="form-control" formControlName="iTrackingCode3"
                            inputmode="numeric" oninput="this.value=this.value.replace(/[^0-9]/g,'')"
                            placeholder="کد پیگیری" />
                    </div>
                </div>

                <div class="col-md-6 field">
                    <label class="field-label" for="f-strPaymentDate">تاریخ ثبت</label>
                    <div class="form-group has-icon mb-0 direction-ltr">
                        <span class="form-control-icon"><mat-icon>date_range</mat-icon></span>
                        <input id="f-strPaymentDate" type="text" class="form-control" formControlName="strPaymentDate"
                            readonly />
                    </div>
                </div>

                <div class="col-md-6 field">
                    <label class="field-label" for="f-strIMEI">IMEI</label>
                    <div class="form-group has-icon mb-0"
                        [ngClass]="formGroup.get('strIMEI')?.value ? 'direction-ltr' : ''">
                        <span class="form-control-icon"><mat-icon>barcode_reader</mat-icon></span>
                        <input id="f-strIMEI" class="form-control" formControlName="strIMEI" inputmode="numeric"
                            maxlength="15" oninput="this.value=this.value.replace(/[^0-9]/g,'')"
                            placeholder="IMEI دستگاه" />
                    </div>
                </div>

                <div class="col-md-6 field">
                    <label class="field-label" for="f-strCellNo">شماره سیم‌کارت</label>
                    <div class="form-group has-icon mb-0"
                        [ngClass]="formGroup.get('strCellNo')?.value ? 'direction-ltr' : ''">
                        <span class="form-control-icon"><mat-icon>settings_phone</mat-icon></span>
                        <input id="f-strCellNo" class="form-control" formControlName="strCellNo" inputmode="numeric"
                            maxlength="11" oninput="this.value=this.value.replace(/[^0-9]/g,'')"
                            placeholder="شماره سیم‌کارت دستگاه" />
                    </div>
                </div>

                <div class="col-12 field">
                    <label class="field-label">امضا</label>
                    <app-signature-field [value]="formGroup.get('strSignatureImage')?.value"
                        [disabled]="isReadonly" (valueChange)="onSignatureChanged($event)"></app-signature-field>
                </div>

                <div class="col-12 field">
                    <label class="field-label" for="f-trackerImage">تصویر محل نصب</label>
                    <div class="tracker-image-box">
                        <input id="f-trackerImage" type="file" class="form-control" accept="image/*"
                            (change)="onTrackerImageSelected($event)" />
                        <div class="tracker-image-preview" *ngIf="trackerImagePreview">
                            <img [src]="trackerImagePreview" alt="تصویر محل نصب" />
                            <button type="button" class="btn btn-outline-danger btn-sm mt-2"
                                (click)="clearTrackerImage()">حذف تصویر</button>
                        </div>
                    </div>
                </div>

            </div>
        </form>
    </div>

    <div class="modal-footer d-flex justify-content-start">
        <button *ngIf="formGroup.get('bCanEdit')?.value" type="button" class="btn btn-primary px-4"
            (click)="submitForm()">ثبت ویرایش</button>
        <button type="button" class="btn btn-outline-secondary px-4" (click)="modal.dismiss()">انصراف</button>
    </div>
</ng-template>
